// KAN-95 暗室（內視鏡室）暗色主題共用工具
// why：內視鏡室在暗環境操作，白底檢查頁造成螢幕炫光、瞳孔放大後更難聚焦。
// 這支把「初值解析 / 套用 root class / 持久化 / 減少動態偏好」收斂成單一真相源，
// 讓 Vuex store 與 main.js 開機防閃共用同一份邏輯，避免兩處判斷漂移。

export const THEME_STORAGE_KEY = 'evas-theme'
export const THEME_LIGHT = 'light'
export const THEME_DARK = 'dark'
// 暗色 root class：掛在 <html>（= CSS :root），讓 theme-dark 覆寫層的自訂屬性生效
const DARK_CLASS = 'theme-dark'

// 解析開機初值：
// 優先讀 localStorage 持久化值（醫師曾手動選過）；沒有才以系統 prefers-color-scheme 當首次 seed。
// why：內視鏡室單次檢查照明穩定，醫師開檢查時切一次即可；系統偏好只當「首次預設」，
// 之後一律以使用者選擇為準（避免自動偵測在檢查中途變色）。
export function resolveInitialTheme () {
  try {
    const saved = window.localStorage.getItem(THEME_STORAGE_KEY)
    if (saved === THEME_DARK || saved === THEME_LIGHT) return saved
  } catch (e) {
    // localStorage 不可用（隱私模式等）→ 落到系統偏好
  }
  if (
    typeof window !== 'undefined' &&
    window.matchMedia &&
    window.matchMedia('(prefers-color-scheme: dark)').matches
  ) {
    return THEME_DARK
  }
  return THEME_LIGHT
}

// 把暗色 class 套到 Vuetify 根（document.documentElement = :root）。
// light 值仍留在 :root，未加 class 時 1:1 與現況相同（不改任何既有 light 樣式）。
export function applyThemeClass (theme) {
  if (typeof document === 'undefined' || !document.documentElement) return
  const root = document.documentElement
  if (theme === THEME_DARK) root.classList.add(DARK_CLASS)
  else root.classList.remove(DARK_CLASS)
}

// 持久化使用者選擇（只有「使用者主動切換」才呼叫；開機 seed 不持久化，
// 好讓系統偏好在使用者尚未明確選擇前仍能生效）
export function persistTheme (theme) {
  try {
    window.localStorage.setItem(THEME_STORAGE_KEY, theme)
  } catch (e) {
    // 無法持久化不影響當次切換，忽略
  }
}

// 是否偏好減少動態（無障礙）——供 scrollToFocus 等 JS 端動效降級判斷
export function prefersReducedMotion () {
  return (
    typeof window !== 'undefined' &&
    !!window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches
  )
}
